import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
    message: string;
    onRetry?: () => void;
    className?: string;
}

export const ErrorState = ({ message, onRetry, className = '' }: ErrorStateProps) => {
    const { t } = useTranslation('codMismatches');

    return (
        <div className={`flex flex-col items-center justify-center py-12 ${className}`}>
            <div className="text-center">
                <p className="text-sm text-destructive mb-4">{message}</p>
                {onRetry && (
                    <Button variant="outline" onClick={onRetry}>
                        {t('error.retry', 'Reintentar')}
                    </Button>
                )}
            </div>
        </div>
    );
};

